// Onglet ARMOR — raccourcis + inventaire du PC fixe de la maison (node Tailscale france-metal).
// Tailnet-only : nécessite Tailscale actif sur l'appareil. Les tuiles ouvrent l'outil dans un nouvel onglet.

const HOST = "france-metal.tail3ea350.ts.net"

type Tool = { name: string; icon: string; desc: string; url: string; tag: string; accent: string }

const TOOLS: Tool[] = [
  { name: "Fichiers (PC entier)", icon: "📂", desc: "Explorateur : tous les disques du PC fixe, échange de fichiers", url: `http://${HOST}:8085`, tag: "Fichiers", accent: "#eab308" },
  { name: "MeshCentral (parc)", icon: "🌐", desc: "Prendre la main à distance : écran, terminal, fichiers, éteindre/redémarrer (appareil ARMOR)", url: "https://srv836585.tail3ea350.ts.net:4430", tag: "Parc", accent: "#0891b2" },
  { name: "Moniteur cartes (parc)", icon: "📊", desc: "Température / charge des cartes de tout le parc (servi par MEGAPORT)", url: "http://kermhitaa.tail3ea350.ts.net:8086", tag: "Parc", accent: "#a855f7" },
]

const APPS: [string, string][] = [
  ["IA", "LM Studio 0.4.6 · Ollama 0.33.3 · Docker Desktop 4.86 (aucun conteneur) · Perplexity · Comet · Antigravity"],
  ["Accès / réseau", "RustDesk 1.4.9 · MeshCentral · Tailscale · Termius · Wave · FileZilla · Proton VPN / Pass / Drive"],
  ["Navigateurs", "Chrome · Brave · Edge · Pulse Browser"],
  ["Vidéo / audio", "OBS Studio · Filmora 13 · VLC · Audacity · AIMP · Mp3tag · FFmpeg · 4K Video Downloader · Molotov"],
  ["Photo", "Luminar Neo · PhotoDirector 365 · PhotoFiltre · XnView MP · Caesium · BorderMaker · HitPaw Watermark Remover"],
  ["Bureautique / notes", "Obsidian 1.12 · LibreOffice · OpenOffice · Thunderbird · Telegram · Discord"],
  ["Disques / système", "Macrium Reflect · AOMEI · MiniTool · DiskGenius · Disk Drill · 4DDiG · CCleaner · CPU-Z · GPU-Z"],
  ["Dev", "Git · Node.js 24 · Java 8 · RipGrep · Local (WordPress)"],
]

export default function PcArmorPage() {
  return (
    <div style={{ height: "100%", overflowY: "auto", backgroundColor: "#111827" }}>
    <div style={{ padding: "24px", maxWidth: "1000px", margin: "0 auto" }}>
      <div style={{ marginBottom: "8px" }}>
        <h1 style={{ margin: 0, fontSize: "24px", color: "#e6edf3" }}>🛡️ ARMOR — PC fixe (france-metal)</h1>
        <p style={{ color: "#8b949e", fontSize: "13px", marginTop: "6px" }}>
          Le <b>PC fixe de la maison</b> (grand boîtier, câble réseau). Tailnet-only : <b>Tailscale doit être actif</b> sur ton appareil.
        </p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: "16px", marginTop: "20px" }}>
        {TOOLS.map((t) => (
          <a key={t.name} href={t.url} target="_blank" rel="noreferrer"
            style={{ display: "block", padding: "18px", borderRadius: "14px", background: "#161b22", border: "1px solid #30363d", textDecoration: "none", color: "#e6edf3", transition: "all .15s" }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = t.accent; e.currentTarget.style.transform = "translateY(-2px)" }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#30363d"; e.currentTarget.style.transform = "translateY(0)" }}
          >
            <div style={{ fontSize: "30px" }}>{t.icon}</div>
            <div style={{ fontWeight: 600, fontSize: "17px", margin: "8px 0 3px" }}>{t.name}</div>
            <div style={{ color: "#8b949e", fontSize: "12px", lineHeight: 1.4 }}>{t.desc}</div>
            <span style={{ display: "inline-block", fontSize: "10px", padding: "2px 8px", borderRadius: "20px", background: "#21262d", color: "#8b949e", marginTop: "10px" }}>{t.tag}</span>
          </a>
        ))}
      </div>

      <div style={{ marginTop: "28px", padding: "16px", borderRadius: "12px", background: "#161b22", border: "1px solid #30363d" }}>
        <b style={{ color: "#e6edf3", fontSize: "14px" }}>🧰 Logiciels installés (sur le PC, pas accessibles depuis le Hub)</b>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "6px 16px", marginTop: "10px" }}>
          {APPS.map(([cat, list]) => (
            <div key={cat} style={{ fontSize: "12px", color: "#8b949e", lineHeight: 1.5 }}>
              <b style={{ color: "#c9d1d9" }}>{cat}</b><br />{list}
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginTop: "28px", padding: "16px", borderRadius: "12px", background: "#161b22", border: "1px solid #30363d", color: "#8b949e", fontSize: "13px", lineHeight: 1.6 }}>
        <b style={{ color: "#e6edf3" }}>ℹ️ Aide-mémoire</b><br />
        • <b>Écran à distance</b> : RustDesk → adresse <b>100.118.194.4</b> (ou MeshCentral, appareil ARMOR). SSH : utilisateur <b>kermhit</b>.<br />
        • <b>Cartes</b> : Quadro K5000 4 Go (écran). Projet : ajouter une <b>Radeon</b> (IA, 2ᵉ alim) → nœud de l'inférence unifiée.<br />
        • <b>Disques</b> (relevé 28/09) : C: 35 Go libres · F: 57 · J: 90 · O: 64 · P: 53 · Q: 10 · <b>L: 5 et M: 4 presque pleins</b>.<br />
        • Toujours sur <b>câble réseau</b> à la maison. Mots de passe → <b>Vaultwarden</b>.
      </div>
    </div>
    </div>
  )
}
